import React,{useState,useEffect} from 'react'
import Partner from '../../components/Partner'
import PartnerService from '../../services/partners.service';

const GovtPartners = () => {
  const [list,setList]=useState([]);
   
 
       

    useEffect(()=>{
      PartnerService.govtList()
      .then(res=>setList(res?.data))
      .catch(err=>console.log(err));

    },[]);
  return (
    <>
    <Partner 
     title={"Government Partners"}
     description={" Ocfit collaborates with various government initiatives focused on skill development and vocational training. These partnerships enable us to effectively reach and financially empower our target populations, aligning our efforts with national goals for workforce development."}
      partners={list}
    />
    </>
  )
}

export default GovtPartners